var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKaktus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.605,
    height: 71.614,
    viewBox: "0 0 77.605 71.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kaktus_logo_1v2",
    transform: "translate(-79.165 -108.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M64.12,93.346,78.7,118.6l7.594-10.956L74.56,87.319l15.48,1.33-7-12L68,75.979,61.266,64.315l-10.43,6.022L60.8,87.5Z",
    transform: "translate(124.984 261.311) rotate(-150)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M7.6,9.76l2.16-3.7-4.332.713L3.7,9.76,1.795,13.069,0,16.182l1.935,3.394,2.777-4.824Z",
    transform: "translate(127 124.531) rotate(-30)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M13.22,25.254,27.8,0l7.594,10.956-9.235,16,14.98-.464-6.5,11.134-15.04.67L10.366,54.285-.065,48.263,9.86,31.073Z",
    transform: "translate(94 129.15) rotate(-30)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M7.6,9.816l2.16,3.7-4.317-.687L3.7,9.816,1.795,6.507,0,3.394,1.935,0,4.712,4.824Z",
    transform: "translate(96.452 150.484) rotate(-150)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaktus);
export default __webpack_public_path__ + "static/media/kaktus.e102ce9d7de73a21e7c95afdbb4b2a39.svg";
export { ForwardRef as ReactComponent };